

import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {

  1: {
    unit: 'Unit 11',
    id: 'SB5-V2-U11-P84-E1',
    audio: 'img/FriendsPlus/Page84/Audio/audio-e1-p84.mp3',
    video: '',
    component: D1,
    recorder: true,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page84/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page84/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page84/Audio/tieude-e1-p84.mp3' },
        { url: 'img/FriendsPlus/Page84/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page84/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page84/E1/5.jpg', audioUrl: 'img/FriendsPlus/Page84/Audio/hinh1-e1-p84.mp3' },
        { url: 'img/FriendsPlus/Page84/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page84/E1/7.jpg', audioUrl: 'img/FriendsPlus/Page84/Audio/hinh2-e1-p84.mp3' },
        { url: 'img/FriendsPlus/Page84/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page84/E1/9.jpg', audioUrl: 'img/FriendsPlus/Page84/Audio/hinh3-e1-p84.mp3' },
        { url: 'img/FriendsPlus/Page84/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page84/E1/11.jpg', audioUrl: 'img/FriendsPlus/Page84/Audio/hinh4-e1-p84.mp3' },
        { url: 'img/FriendsPlus/Page84/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page84/E1/13.jpg', audioUrl: 'img/FriendsPlus/Page84/Audio/hinh5-e1-p84.mp3' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page84/E1/3.jpg' },
        { url: 'img/FriendsPlus/Page84/E1/3.jpg' },
      ],

    ]
  },

  2: {
    unit: 'Unit 11',
    id: 'SB5-V2-U11-P84-E2',
    audio: 'img/FriendsPlus/Page84/Audio/audio-e2-p84.mp3',
    video: '',
    component: UI,
    recorder: true,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page84/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page84/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page84/Audio/tieude-e2-p84.mp3' },
        { url: 'img/FriendsPlus/Page84/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page84/E2/4.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page84/E2/3.jpg' },
      ],


    ]
  },
  3: {
    unit: 'Unit 11',
    id: 'SB5-V2-U11-P84-E3',
    audio: '',
    video: '',
    component: D1,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page84/E3/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page84/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page84/E2/4.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page84/E3/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page84/E3/3.jpg' },
        { url: 'img/FriendsPlus/Page84/E3/4.jpg', input: true, answer: "hill" },
        { url: 'img/FriendsPlus/Page84/E3/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page84/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page84/E3/7.jpg', input: true, answer: "clothes" },
        { url: 'img/FriendsPlus/Page84/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page84/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page84/E3/10.jpg', input: true, answer: "happy" },
        { url: 'img/FriendsPlus/Page84/E3/11.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page83/E1/3.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page83/E1/3.jpg' },
      ],



    ]
  },




}
export default json;
